import script from "./SoaDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SoaDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./SoaDetailsView.vue?vue&type=style&index=0&id=71742afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71742afe"]])

export default __exports__